import { useCallback } from 'react';
import { readLocaleCookie } from 'helpers/localeCookie';
import { TranslationOptions } from './types';
import { useI18n } from '../..';

const useTranslation = () => {
  const { translations } = useI18n();

  const locale = readLocaleCookie();

  const translate = useCallback(
    (token: string, { values = {}, defaultMessage = '' }: TranslationOptions = {}) => {
      // Token will be like this {namespace}.{c1}.{c2}... (.eg: common.say.hi)

      const fallbackMessage = defaultMessage || token || '';

      if (!translations) return fallbackMessage;

      const firstDotIndex = token.indexOf('.');

      if (firstDotIndex === -1) return fallbackMessage;

      const [namespace, key] = [token.substring(0, firstDotIndex), token.substring(firstDotIndex + 1)];

      let message = translations[locale]?.[namespace]?.[key] ?? fallbackMessage;

      for (const placeholder of Object.keys(values)) {
        // regex expressions are always defined in code, they don't depend on user input, so it's fine to dinamically use the placeholder here
        message = message.replace(new RegExp(`{${placeholder}}`, 'g'), (values[placeholder] ?? '').toString());
      }

      return message;
    },
    [translations, locale],
  );

  return { translate };
};

export default useTranslation;
